/*
 * Created Date: 15-03-2024, 5:18:08 pm
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified: Sat Mar 16 2024
 * Modified By: Victor
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { ROUTER_PERSONAL_DASHBOARD } from '@App/Studio/Modules/Personal/Dashboard/configs/const'
import { ROUTER_WORKSPACE_EXAM } from '@App/Studio/Modules/Workspace/Exam/configs/const'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const ErrorPageContainer = props => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	return (
		<div className="p-5 md:py-28 md:px-60 flex h-full flex-col justify-center items-center bg-[#FFFFFF] gap-24">
			{props.children}
			<Button
				onClick={() => {
					navigate(ROUTER_PERSONAL_DASHBOARD.dashboard)
				}}
				variant="main-gradient"
				className="px-16 py-12 rounded-8 text-12 leading-20 font-500"
			>
				{t('Quay lại trang chủ')}
			</Button>
		</div>
	)
}
export default ErrorPageContainer
